// extracted by mini-css-extract-plugin
export default {"container":"JoinSection_container__J3t04","title":"JoinSection_title__U3D1u","grid":"JoinSection_grid__NxIUk","card":"JoinSection_card__zroy9","icon":"JoinSection_icon__QeBb6"};